module.exports = __webpack_public_path__ + "static/media/matalanoireetA4suomeksi.8d54806f.png";